import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useWindowWidth } from '../../../utils';
import Select from 'react-select';
import UserCell from '../../../components/admin/UserCell';
import questionImg from '../../../assets/images/question.svg';
import closeImg from '../../../assets/images/close.svg';
import Avatar from 'react-avatar';
import firebase from '../../../firebase';

import { updateUser, deleteUser } from '../../../actions/user';

const customStyles = {
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isFocused ? '#F2F2F2' : null,
    color: '#000000',
    padding: '8px 0 8px 16px',
    fontSize: 14,
    fontWeight: isSelected ? 600 : 300,
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),
};

const Users = ({ users }) => {
  const width = useWindowWidth();
  const dispatch = useDispatch();
  const uploaderRef = useRef();

  const [selected, setSelected] = useState('');
  const [isShowEditUserModal, setShowEditUserModal] = useState(false);
  const [isShowDeleteUserModal, setShowDeleteUserModal] = useState(false);

  const handleEditChange = (name, e) => {
    setSelected({ ...selected, [name]: e });
  };

  const handleEditUser = () => {
    if (!selected.firstName || !selected.lastName) return;
    dispatch(
      updateUser({
        ...selected,
        firstName: selected.firstName,
        lastName: selected.lastName,
        email: selected.email,
        role: selected.role.value,
        updatedAt: new Date(),
      }),
    );
    setShowEditUserModal(false);
  };

  const handleDeleteUser = () => {
    dispatch(deleteUser(selected.id));
    setShowDeleteUserModal(false);
  };

  const renderTooltip = (props) => (
    <Tooltip id="custom-tooltip" {...props}>
      <div className="custom-tooltip">
        <div className="tooltip-header">User!</div>
        <div className="tooltip-content">
          Here is where you add the relationships between your stakeholders. These become arrows in
          the web.
        </div>
      </div>
    </Tooltip>
  );

  const handleUploadAvatar = (e) => {
    const file = uploaderRef.current.files[0];
    var storage = firebase.storage();
    var storageRef = storage.ref();
    var uploadTask = storageRef.child('avatars/' + file.name).put(file);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('upload progress...', progress);
      },
      (error) => {
        throw error;
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
          console.log('upload complete', url);
          setSelected({ ...selected, avatar: url });
        });
      },
    );
  };

  const roles = [
    { label: 'user', value: 'user' },
    { label: 'admin', value: 'admin' },
  ];

  const [searchStr, setSearchStr] = useState('');

  return (
    <>
      <div className="user-section">
        <div className="user-section-header">
          <div className="text-section">
            <p>Users</p>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <img src={questionImg} alt="quiz" />
            </OverlayTrigger>
          </div>
          <div className="right-section">
            <input
              id="filter"
              name="filter"
              value={searchStr}
              onChange={(e) => setSearchStr(e.target.value)}
              placeholder="Search"
              classNamePrefix="custom-select"
              className="custom-select"
            />
          </div>
        </div>
        <div className="user-list">
          {width > 600 ? (
            <div className="user-list-header">
              <div className="item-id">#</div>
              <div className="item-type">First Name</div>
              <div className="item-from">Last Name</div>
              <div className="item-to">Email</div>
              <div className="item-notes">Role</div>
            </div>
          ) : (
            <></>
          )}
          <div className="user-list-content">
            {users
              .filter((user) => {
                return (
                  user.firstName.includes(searchStr) ||
                  user.lastName.includes(searchStr) ||
                  user.email.includes(searchStr)
                );
              })
              .map((user, index) => (
                <UserCell
                  user={user}
                  key={user.id}
                  index={index + 1}
                  setShowEditUserModal={setShowEditUserModal}
                  setShowDeleteUserModal={setShowDeleteUserModal}
                  setSelected={setSelected}
                />
              ))}
          </div>
        </div>
      </div>

      {isShowEditUserModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowEditUserModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Edit User</h1>
              <div className="form-item">
                <label htmlFor="type">Avatar</label>
                <div>
                  {selected.avatar ? (
                    <img className="avatar-image" src={selected.avatar} />
                  ) : (
                    <Avatar
                      color={Avatar.getRandomColor(selected.firstName + ' ' + selected.lastName, [
                        'red',
                        'green',
                        'blue',
                      ])}
                      name={selected.firstName + ' ' + selected.lastName}
                    />
                  )}
                  <button
                    className="primary-btn upload-btn"
                    onClick={() => uploaderRef.current.click()}
                  >
                    Upload/Change
                  </button>
                  <input
                    type="file"
                    ref={uploaderRef}
                    id="avatar-upload-input"
                    accept="image/*"
                    onChange={(e) => handleUploadAvatar(e)}
                  />
                </div>
              </div>
              <div className="form-item">
                <label htmlFor="type">First Name</label>
                <input
                  type="text"
                  placeholder="Type your first name"
                  value={selected.firstName}
                  onChange={(e) => handleEditChange('firstName', e.target.value)}
                />
              </div>
              <div className="form-item">
                <label htmlFor="type">Last Name</label>
                <input
                  type="text"
                  placeholder="Type your last name"
                  value={selected.lastName}
                  onChange={(e) => handleEditChange('lastName', e.target.value)}
                />
              </div>
              <div className="form-item">
                <label htmlFor="to">Role</label>
                <Select
                  id="edit-to"
                  name="role"
                  value={selected.role}
                  onChange={(e) => handleEditChange('role', e)}
                  options={roles}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.value}
                  getOptionLabel={(option) => option.label}
                />
              </div>
              <button className="primary-btn solo-btn" onClick={handleEditUser}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isShowDeleteUserModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowDeleteUserModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">
                Are you sure, that you want to delete {selected.firstName} {selected.lastName} ?
              </h1>
              <div className="modal-actions">
                <button className="primary-btn" onClick={handleDeleteUser}>
                  Yes
                </button>
                <button className="outline-btn" onClick={() => setShowDeleteUserModal(false)}>
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Users;
